module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.tag !== null) ? _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-6"
  }, [_c('tag-form', {
    attrs: {
      "tag": _vm.tag
    },
    on: {
      "saved": _vm.reloadTag
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "column is-6"
  }, [_c('h2', {
    staticClass: "subtitle"
  }, [_vm._v("Products with this tag")]), _vm._v(" "), _vm._l((_vm.linkedProducts), function(product) {
    return _c('div', [_c('router-link', {
      attrs: {
        "to": {
          name: 'product',
          params: {
            id: product.id
          }
        }
      }
    }, [_vm._v("\n                    " + _vm._s(product.name) + "\n                ")])], 1)
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', [_vm._v("Add tag to product...")])], 2)]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b6dfaf32"}!./~/vue-loader/lib/selector.js?type=template&index=0!./vue/src/views/catalog/tags/TagEdit.vue
// module id = 575
// module chunks = 0